import { useEffect } from 'react';
import { Flex, Paper, Radio, Text } from '@mantine/core';
import { StepCard } from 'src/UI/generate-flow/StepCard';
import useTemplates from 'src/data-capture/hooks/templates/useTemplates';
import { AgendaStepProps } from '../types';
import { SelectableList } from 'src/UI/generate-flow/SelectableList';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export function AgendaTemplateStep({ data, setData }: AgendaStepProps) {
  const { files: templates, isLoading } = useTemplates({ templateType: 'MEETING_AGENDA' });

  useEffect(() => {
    if (!data.template && templates.length > 0) {
      const defaultTemplate = templates.find(t => t.isDefault);
      if (defaultTemplate) {
        setData(prev => ({ ...prev, template: defaultTemplate }));
      }
    }
  }, [templates, data.template, setData]);

  if (isLoading) {
    return null;
  }

  return (
    <Flex direction="column" h="100%" mih={0}>
      <StepCard title="Select a template for the meeting agenda">
        <SelectableList
          items={templates}
          getKey={t => t.id}
          renderRow={template => (
            <Paper
              radius="12"
              withBorder
              px="md"
              py="sm"
              role="button"
              tabIndex={0}
              onClick={() => setData(prev => ({ ...prev, template }))}
              styles={theme => ({
                root: {
                  cursor: 'pointer',
                  borderColor:
                    data.template?.id === template.id
                      ? theme.colors.brand[6]
                      : 'var(--default-border-color)',
                  boxShadow: 'none',
                  userSelect: 'none',
                },
              })}
            >
              <Flex align="center" gap="md">
                <Radio
                  checked={data.template?.id === template.id}
                  onChange={() => setData(prev => ({ ...prev, template }))}
                  color="brand"
                  size="md"
                  iconColor="white"
                />
                <Text fw={FONT_WEIGHTS.semibold} size="sm" c="gray.8">
                  {template.displayName}
                </Text>
              </Flex>
            </Paper>
          )}
        />
      </StepCard>
    </Flex>
  );
}
